import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute } from '@tanstack/react-router'

import { useGlobalLogout } from '@/hooks/use-global-logout'

function LoadingComponent() {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="text-lg">Logging out...</div>
    </div>
  )
}

export const Route = createFileRoute('/_auth/logout')({
  component: LogoutPage,
})

function LogoutPage() {
  const { isAuthenticated, loginWithRedirect } = useAuth0()
  const logout = useGlobalLogout()

  if (isAuthenticated) logout()

  loginWithRedirect()

  return <LoadingComponent />
}
